export default __webpack_public_path__ + "static/media/chance.77489c19.png";